
















































































































import moment from 'moment'
import getVSelectOptionByValue from 'piramis-js-utils/lib/getVSelectOptionByValue'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import { SelectOption } from '../../../../../../logic/types'
import { Subscription } from '../../../../../../shared/types/BotUsers'
import ChannelSubscriptionInfo from '../../../../../ChannelSubscriptionInfo/ChannelSubscriptionInfo.vue'
import { StepUnit } from '../../../../../PeriodSimplifier/types'
import { UseFields } from '../../../../../Pi'
import { FieldData } from '../../../../../Pi/types'
import { SubscriptionsHelper } from '../../../../types'

@Component({
  components: {
    ChannelSubscriptionInfo
  },
  data() {
    return {
      isMobile,
      StepUnit,
      moment,
    }
  }
})
export default class SubscriptionEditor extends UseFields {
  @VModel() subscription!: { channel: number, time: number, action: 'edit' | 'add', expire?: string } | null

  @Prop() getChannelTitle!: (id: number) => string | undefined

  @Prop() userId!: number

  @Prop() freeChannels!: Array<SelectOption>

  @Prop() createSubscription!: (user_id: number, channel_id: number, duration: number) => Promise<Subscription>

  @Prop() subscriptionsHelper!: SubscriptionsHelper

  get isOpen(): boolean {
    return !!this.subscription
  }

  get channelTitle() {
    if (this.subscription) {
      const { channel } = this.subscription
      const option = getVSelectOptionByValue(this.freeChannels, channel)

      if (option) {
        return option.label
      }

      return channel
    }

    return ''
  }

  modelSetter(arg: FieldData): FieldData {
    arg.setter = (val) => {
      arg.model[arg.key] = val
    }
    return arg
  }

  removeSubscriptionTime(): void {
    if (this.subscription) {
      this.subscription.time = this.subscription.time > 0 ? this.subscription.time * -1 : this.subscription.time
      this.setSubscription()
    }
  }

  setSubscriptionTime(): void {
    if (this.subscription) {
      this.subscription.time = this.subscription.time > 0 ? this.subscription.time : this.subscription.time * -1
      this.setSubscription()
    }
  }

  setSubscription(): void {
    if (this.subscription && this.subscription.channel && this.subscription.time) {
      this.createSubscription(this.userId, this.subscription.channel, this.subscription.time * 60)
        .then((subscription) => this.setEditableSubscription(subscription))
        .finally(() => this.subscription = null)
    }
  }

  @Emit('setEditableSubscription')
  setEditableSubscription(subscription: Subscription): Subscription {
    return subscription
  }
}
